import { Box } from '@rebass/grid';
import { styled } from 'styles';

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 5px;
`;

export const Text = styled.p`
  font-size: 1.4rem;
`;

export const UriItem = styled(Box)`
  font-size: 1.4rem;
`;

export const UriLink = styled.a`
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  opacity: 0.9;

  &:hover {
    opacity: 1;
  }
`;

export const IconWrapper = styled.span`
  font-size: 2.4rem;
  width: 40px;
  padding-top: 4px;
  display: inline-block;
`;
